import store from '../store/store';
export default function getMailboxForwardingConfiguration() {
    return store.mailboxForwardingConfiguration;
}
//# sourceMappingURL=getMailboxForwardingConfiguration.js.map